( function( app ) {
  const COMPONENT = {
    init: function() {
      const truck = document.querySelector( '.four-oh-four__big-ol-truck' );
      if ( !truck ) return;

      // Force a reflow before adding the class so the transition from
      // -left-full to is-active actually animates on page load
      requestAnimationFrame( () => {
        requestAnimationFrame( () => {
          truck.classList.add( 'is-active' );
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'four-oh-four', COMPONENT );
} )( app );
